<template>
    <div>
      <mcheader></mcheader>
      <div class="Caddress" style="margin-top: 100px">
        <div class="open_new">
          <button class="open_btn" @click="onclick_open">使用新地址</button>
          <button class="open_btn" @click="onclick_delete">删除该地址</button>
          <button class="open_btn" @click="onclick_revice">修改该地址</button>

        </div>
        <div class="add_mi" v-for="(item,index) in Address" :key="index" @click="changestyle(index)" :class="{changeStyle:changeSelectStyle == index}" style="">
          <p style="border-bottom:1px dashed #ccc;line-height:28px;">{{item.username}}{{item.phone}}</p>
          <p>{{item.province}}{{item.city}}{{item.detail_address}}</p>
        </div>
        <!--<div class="add_mi" >-->
          <!--<p style="border-bottom:1px dashed #ccc;line-height:28px;">浙江杭州(爸爸收)</p>-->
          <!--<p>萧山 北干 明怡花苑53幢3单元 13735683918</p>-->
        <!--</div>-->
        <!--<div class="add_mi">-->
        <!--<p style="border-bottom:1px dashed #ccc;line-height:28px;">浙江杭州(爸爸收)</p>-->
        <!--<p>萧山 北干 明怡花苑53幢3单元 13735683918</p>-->
        <!--</div>-->
        <!--<div class="add_mi">-->
          <!--<p style="border-bottom:1px dashed #ccc;line-height:28px;">浙江杭州(爸爸收)</p>-->
          <!--<p>萧山 北干 明怡花苑53幢3单元 13735683918</p>-->
        <!--</div>-->
        <!--<div class="add_mi">-->
          <!--<p style="border-bottom:1px dashed #ccc;line-height:28px;">浙江杭州(爸爸收)</p>-->
          <!--<p>萧山 北干 明怡花苑53幢3单元 13735683918</p>-->
        <!--</div>-->
        <div style="clear: both"></div>
      </div>

      <div class="shopping_content">
        <div class="shopping_table">
          <table border="1" bordercolor="#cccccc" cellspacing="0" cellpadding="0" style="width: 100%; text-align: center;">
            <tr>
              <th>商品图片</th>
              <th>商品名称</th>
              <th>商品属性</th>
              <th>商品价格</th>
              <th>商品数量</th>
              <th>商品操作</th>
            </tr>
            <tr v-for="(item , index) in shopcarList" :key="index">
              <td>
                <img :src="item.imgUrl" alt="" style="width: 60px;height: 60px;margin: 10px 0">
              </td>
              <td><span>{{item.name}}</span></td>
              <td>
                <div class="">
                  <span >颜色</span>：<span>{{item.norm2}}</span>
                </div>
                <div class="">
                  <span >尺码</span>：<span>{{item.norm1}}</span>
                </div>
              </td>
              <td>
                <span class="span_momey">{{item.price}}</span>
              </td>
              <td>
                <input class="momey_input" type="" name="" id="" value="1" disabled="disabled" />
              </td>
              <td>
                <button class="btn_r" @click="onclick_remove(index)">删除</button>
              </td>
            </tr>
          </table>
          <div class="" style="width: 100%; text-align: right; margin-top: 10px;">
            <div class="div_outMumey" style="float: left;">
              总价：<span class="out_momey">${{total1}}</span>
            </div>
            <button class="btn_closing" @click="gopay">结算</button>
          </div>
        </div>
      </div>

      <div class="shade" style="display: none">
      </div>

        <div class="shade_content" style="display: none;margin-bottom: 200px" id="add">
        <div class="col-xs-12 shade_colse">
          <button @click="onclick_close">x</button>
        </div>
        <div class="nav shade_content_div" >
          <div class="col-xs-12 shade_title">
            新增地址
          </div>
          <div class="col-xs-12 shade_from">
            <form action="" method="post">
              <div class="col-xs-12">
                <span class="span_style" >姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
                <input class="input_style" type="" name=""  value=""  v-model="newTabActivityData.activityRule.username" placeholder="请输入您的姓名" />
              </div>
              <div class="col-xs-12">
                <span class="span_style" >手机号码</span>
                <input class="input_style" type="" name=""  value=""  v-model="newTabActivityData.activityRule.phone" placeholder="请输入您的手机号" />
              </div>
              <div class="col-xs-12">
                <span class="span_style span_sty" >省&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市</span>
                <input class="input_style" type="" name=""  value=""  v-model="newTabActivityData.activityRule.region" placeholder="请输入您的所在省市区" />
              </div>
              <div class="col-xs-12">
                <span class="span_style" >详细地址</span>
                <input class="input_style" type="" name=""  value="" v-model="newTabActivityData.activityRule.address" placeholder="请输入您的详细地址" />
              </div>
              <div class="col-xs-12">
                <input class="btn_remove" type="button"  @click="onclick_close" value="取消" />
                <input  class="sub_set" type="button"  value="提交" @click="submitNewActivity()" style="text-align: center"/>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="shade_content" style="display: none;margin-bottom: 200px" id="revice">
        <div class="col-xs-12 shade_colse">
          <button @click="onclick_close">x</button>
        </div>
        <div class="nav shade_content_div" >
          <div class="col-xs-12 shade_title">
            修改地址
          </div>
          <div class="col-xs-12 shade_from">
            <form action="" method="post">
              <div class="col-xs-12">
                <span class="span_style" >姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
                <input class="input_style" type="" name="" id="region" value=""  v-model="revTabActivityData.activityRule.username" placeholder="请输入您的姓名" />
              </div>
              <div class="col-xs-12">
                <span class="span_style" >手机号码</span>
                <input class="input_style" type="" name="" id="address" value=""  v-model="revTabActivityData.activityRule.phone" placeholder="请输入您的手机号" />
              </div>
              <div class="col-xs-12">
                <span class="span_style span_sty" >省&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市（区域）</span>
                <input class="input_style" type="" name="" id="username" value=""  v-model="revTabActivityData.activityRule.region" placeholder="请输入您的所在省市区" />
              </div>
              <div class="col-xs-12">
                <span class="span_style" >详细地址</span>
                <input class="input_style" type="" name="" id="phone" value="" v-model="revTabActivityData.activityRule.address" placeholder="请输入您的详细地址" />
              </div>
              <div class="col-xs-12">
                <input class="btn_remove" type="button"  @click="onclick_close" value="取消" />
                  <input  class="sub_set" id="sub_setID" type="button" value="提交" @click="revice()" style="text-align: center;cursor: pointer"/>
              </div>
            </form>
          </div>
        </div>
      </div>
      <mcfoot></mcfoot>
    </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
import https from './js/https.js'
export default {
  name: 'order',
  components:
    {
      mcheader,
      mcfoot
    },
  data () {
    return {
      Address: [],
      changeSelectStyle: '',
      newTabActivityData: {
        activityRule: [{region: '', address: '', username: '', phone: ''}]
      },
      revTabActivityData: {
        activityRule: [{region: '', address: '', username: '', phone: ''}]
      },
      selectaddress: 0,
      shopcarList: [],
      total1: 0,
      onetotal1: '' // 单个表格总价
    }
  },
  methods: {
    onclick_close () {
      var shade_content = $('.shade_content')
      var shade = $('.shade')
      shade_content.hide()
      shade.hide()
    },
    onclick_open () {
      $('#add').show()
      $('.shade').show()
      var input_out = $('.input_style')
      for (var i = 0; i <= input_out.length; i++) {
        if ($(input_out[i]).val() != '') {
          $(input_out[i]).val('')
        }
      }
    },
    onclick_revice () {
      $('#revice').show()
      $('.shade').show()
      var input_out = $('.input_style')
      for (var i = 0; i <= input_out.length; i++) {
        if ($(input_out[i]).val() != '') {
          $(input_out[i]).val('')
        }
      }
    },
    onclick_remove (index) {
      this.total1 = 0
      console.log(index)
      this.shopcarList.splice(index, 1)
      if (confirm('确认删除吗？')) {
        this.total()
      } else {

      }
    },
    onclick_btnAdd (a) {
      var out_momey = $('.out_momey')
      var input_ = $(a).prev()
      var input_val = $(a).prev().val()
      var input_add = parseInt(input_val) + 1
      input_.val(input_add)
      var btn_momey = parseFloat($(a).parent().prev().children().html())
      var out_momey_float = parseFloat(out_momey.html()) + btn_momey
      out_momey.text(out_momey_float.toFixed(2))
      console.log(a)
      console.log(out_momey)
      console.log(input_val)
      console.log(input_)
    },
    onclick_reduce (b) {
      var out_momey = $('.out_momey')
      var input_ = $(b).next()
      var input_val = $(b).next().val()
      if (input_val <= 1) {
        alert('商品个数不能小于1！')
      } else {
        var input_add = parseInt(input_val) - 1
        input_.val(input_add)
        var btn_momey = parseFloat($(b).parent().prev().children().html())
        var out_momey_float = parseFloat(out_momey.html()) - btn_momey
        out_momey.text(out_momey_float.toFixed(2))
      }
    },
    total () {
      for (var i = 0; i < this.shopcarList.length; i++) {
        this.onetotal1 = (parseInt((this.shopcarList[i].price)) * parseInt((this.shopcarList[i].productCount))).toFixed(2)
        this.total1 = (parseInt(this.onetotal1) + parseInt(this.total1)).toFixed(2)
        console.log(this.onetotal1)
        console.log(this.total1)
      }
    },
    // 获取地址信息
    getaddress () {
      var userid = sessionStorage.getItem('userId')
      if (userid == null) {
        this.open()
      } else {
        console.log(this.$route.query.shopcarList)
        this.shopcarList = JSON.parse(this.$route.query.shopcarList)
        console.log(this.shopcarList)
        this.total()
        this.total1 = this.$route.query.total1
        https.fetchGet('mocalilie/api/address/queryAll', {
          page: 1,
          size: 1000,
          userId: userid
        }).then((res) => {
          console.log(res.data.data)
          this.Address = res.data.data.addressList
        })
      }
    },
    changestyle (index) {
      this.changeSelectStyle = index
      this.selectaddress = index
      console.log(this.changeSelectStyle)
    },
    // 添加新地址
    submitNewActivity () {
      console.log(this.changeSelectStyle)
      var phone = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
      if (this.newTabActivityData.activityRule.username == '' || this.newTabActivityData.activityRule.username == undefined) {
        this.$alert('请输入用户名', '提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        })
      } else if (this.newTabActivityData.activityRule.phone == '' || !phone.test(this.newTabActivityData.activityRule.phone)) {
        this.$alert('请输入正确的手机号', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
      } else if (this.newTabActivityData.activityRule.region == '' || this.newTabActivityData.activityRule.region == undefined) {
        this.$alert('请输入省市区', '提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        })
      } else if (this.newTabActivityData.activityRule.address == '' || this.newTabActivityData.activityRule.address == undefined) {
        this.$alert('请输入您的详细地址', '提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        })
      } else {
        https.fetchPost('mocalilie/api/address/updateAddress', {
          username: this.newTabActivityData.activityRule.username,
          phone: this.newTabActivityData.activityRule.phone,
          user_id: '20190419155566294291001755805745',
          province: this.newTabActivityData.activityRule.region,
          city: '',
          area: '',
          address: '',
          detail_address: this.newTabActivityData.activityRule.address
        }).then((res) => {
          console.log(res)
          this.getaddress()
          this.onclick_close()
        })
      }
    },
    // 删除地址
    onclick_delete () {
      this.$confirm('确认要删除地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var addressid = this.Address[this.selectaddress].id
        console.log(addressid)
        https.fetchPost('mocalilie/api/address/delAddress', {
          id: addressid
        }).then((res) => {
          console.log(res)
          this.getaddress()
        })
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 修改地址
    revice () {
      var addressid = this.Address[this.selectaddress].id
      console.log(addressid)
      https.fetchPost('mocalilie/api/address/updateAddress', {
        username: this.revTabActivityData.activityRule.username,
        phone: this.revTabActivityData.activityRule.phone,
        user_id: '20190419155566294291001755805745',
        province: this.revTabActivityData.activityRule.region,
        city: '',
        area: '',
        address: '',
        detail_address: this.revTabActivityData.activityRule.address,
        id: addressid
      }).then((res) => {
        console.log(res)
        this.getaddress()
        this.onclick_close()
      })
    },
    gopay () {
      var userid = sessionStorage.getItem('userId')
      if (userid == null) {
        this.open()
      } else {
        var addressid = this.Address[this.selectaddress].id
        var selectIdList = []
        this.shopcarList.forEach(function (value) {
          selectIdList.push({ 'productNormId': value.productNormId, 'productCount': value.productCount })
        })
        var orderInfoDTOList = JSON.stringify(selectIdList)
        console.log(selectIdList)
        this.$router.push('pay')
        https.fetchPost('mocalilie/api/order/createOrder', {
          orderInfoDTOList: orderInfoDTOList,
          leaveMessage: 'aaaaa',
          userId: userid,
          detail_address: this.revTabActivityData.activityRule.address,
          addressId: addressid
        }).then((res) => {
          console.log(res)
          this.$router.push({
            name: 'pay',
            query: {
              orderInfoId: res.data.data.orderInfoId
            }
          })
        })
      }
    },
    open () {
      this.$confirm('当前未登陆，请登陆你的账户', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false,
        center: true
      }).then(() => {
        this.$router.push('/login')
      })
    }
  },
  mounted () {
    this.getaddress()
  }
}
$(function () {
  var region = $('#region')
  var address = $('#address')
  var number_this = $('#number_this')
  var name = $('#name_')
  var phone = $('#phone')
  console.log('aaa')

  var span_momey = $('.span_momey')
  var b = 0
  for (var i = 0; i < span_momey.length; i++) {
    b += parseFloat($(span_momey[i]).html())
  }
  var out_momey = $('.out_momey')
  out_momey.html(b)
  $('.shade_content').hide()
  $('.shade').hide()
  $('.nav_mini ul li').hover(function () {
    $(this).find('.two_nav').show(100)
  }, function () {
    $(this).find('.two_nav').hide(100)
  })
  $('.left_nav').hover(function () {
    $(this).find('.nav_mini').show(100)
  }, function () {
    $(this).find('.nav_mini').hide(100)
  })
  $('#jia').click(function () {
    $('input[name=num]').val(parseInt($('input[name=num]').val()) + 1)
  })
  $('#jian').click(function () {
    $('input[name=num]').val(parseInt($('input[name=num]').val()) - 1)
  })
  $('.Caddress .add_mi').click(function () {
    $(this).css('background', 'url("../static/testimonial/mail_1.jpg") no-repeat').siblings('.add_mi').css('background', 'url("../static/testimonial/mail.jpg") no-repeat')
    console.log('bbb')
  })
})
</script>

<style scoped>
  @import "../static/css.css";
  th{
    text-align: center;
  }
  .changeStyle {
    background-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/order.vue